import { render, staticRenderFns } from "./CmsTypes.vue?vue&type=template&id=7632d7d8&"
import script from "./CmsTypes.vue?vue&type=script&lang=js&"
export * from "./CmsTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports